import { Button, Divider, Grid } from '@material-ui/core'
import React from 'react'
import { useStyles } from './index'

const DialogFooter = ({
  handleClose,
  isAuthenticated,
  isNewQuestionnaire,
  onSave,
}) => {
  const classes = useStyles()

  const unauthenticatedMessage = 'Please login to save your data'
  const createMessage = isAuthenticated
    ? isNewQuestionnaire
      ? 'Create'
      : 'Save as new'
    : unauthenticatedMessage

  return (
    <div className={classes.stickyBot}>
      <Divider />
      <Grid
        container
        direction='row'
        justifyContent='center'
        alignItems='center'
      >
        <Grid item xs>
          <Button
            disableElevation
            className={classes.button1}
            color='secondary'
            onClick={handleClose}
          >
            Close
          </Button>
        </Grid>
        <Divider
          orientation='vertical'
          flexItem
          style={{ marginRight: '-1px' }}
        />
        {!isNewQuestionnaire && (
          <>
            <Grid item xs>
              <Button
                disableElevation
                className={classes.button2}
                color='primary'
                onClick={onSave}
                disabled={!isAuthenticated}
              >
                {isAuthenticated ? 'Save' : unauthenticatedMessage}
              </Button>
            </Grid>
            <Divider
              orientation='vertical'
              flexItem
              style={{ marginRight: '-1px' }}
            />
          </>
        )}
        <Grid item xs>
          <Button
            disableElevation
            className={classes.button2}
            color='primary'
            type='submit'
            disabled={!isAuthenticated}
          >
            {createMessage}
          </Button>
        </Grid>
      </Grid>
    </div>
  )
}

export default DialogFooter
